"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGiveawaySchedulerConfigs200ResponseToJSON = exports.GetGiveawaySchedulerConfigs200ResponseFromJSONTyped = exports.GetGiveawaySchedulerConfigs200ResponseFromJSON = exports.instanceOfGetGiveawaySchedulerConfigs200Response = void 0;
var GiveawaySchedulerConfig_1 = require("./GiveawaySchedulerConfig");
/**
 * Check if a given object implements the GetGiveawaySchedulerConfigs200Response interface.
 */
function instanceOfGetGiveawaySchedulerConfigs200Response(value) {
    var isInstance = true;
    isInstance = isInstance && "data" in value;
    return isInstance;
}
exports.instanceOfGetGiveawaySchedulerConfigs200Response = instanceOfGetGiveawaySchedulerConfigs200Response;
function GetGiveawaySchedulerConfigs200ResponseFromJSON(json) {
    return GetGiveawaySchedulerConfigs200ResponseFromJSONTyped(json, false);
}
exports.GetGiveawaySchedulerConfigs200ResponseFromJSON = GetGiveawaySchedulerConfigs200ResponseFromJSON;
function GetGiveawaySchedulerConfigs200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (json['data'].map(GiveawaySchedulerConfig_1.GiveawaySchedulerConfigFromJSON)),
    };
}
exports.GetGiveawaySchedulerConfigs200ResponseFromJSONTyped = GetGiveawaySchedulerConfigs200ResponseFromJSONTyped;
function GetGiveawaySchedulerConfigs200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (value.data.map(GiveawaySchedulerConfig_1.GiveawaySchedulerConfigToJSON)),
    };
}
exports.GetGiveawaySchedulerConfigs200ResponseToJSON = GetGiveawaySchedulerConfigs200ResponseToJSON;
